{
	"dropzoneTitle": "Drag and drop the file here",
	"dropzoneSubtitle": "or click to select the file",
	"fileDetails": "File type: {{fileType}} up to {{fileSize}}",
	"downloadSample": "Download sample table",
	"downloadInvalidSheet": "Download table with errors",
	"errorImporting": "Could not import the table",
	"errorInvalidHeader": "The spreadsheet columns do not match the expected template. Download a new template and try again.",
	"errorUnreadableFile": "Could not read the file. Make sure it is a valid, uncorrupted .xlsx file.",
	"errorEmptySheet": "The spreadsheet is empty.",
	"errorEmptyHeaderCell": "There is a column without a title in the header. Use the default template and do not leave columns unnamed.",
	"selectFile": "Select a file",
	"selectAnotherFile": "Select another file",
	"invalidFileTitle": "The selected file is invalid",
	"invalidFileReasonInvalidType": "Unsupported file type. Use {{formats}} files.",
	"invalidFileReasonTooLarge": "The file exceeds the maximum size of {{maxSize}}.",
	"invalidFileReasonTooManyFiles": "Only {{maxFiles}} file can be uploaded at a time.",
	"invalidFileReasonTooSmall": "The file is smaller than allowed.",
	"invalidFileReasonDefault": "The file cannot be imported. Check the requirements and try again.",
	"confirmCloseDialog": {
		"title": "Exit import in bulk",
		"description": "Are you sure you want to exit the import in bulk without downloading the error sheet?",
		"descriptionStrong": "You will not be able to download it again and will lose this information.",
		"cancel": "Exit editing",
		"download": "Download error sheet"
	},
	"importNewFile": "Import new file"
}
